import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DescriptionIcon from '@mui/icons-material/Description';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { CircleNotificationsOutlined, CircleNotificationsRounded, LogoutOutlined, NotificationAddOutlined } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import LogoCM from '../img/LogoCM.png'
// import userimg from '../img/userimg.png'
import { useNavigate } from 'react-router-dom';
import "./SideBar.css";
import { Link } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { API_URL } from '../config'
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';



const drawerWidth = 240;

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      isClosing: false,
      selectedOption: this.props.poNumber ? this.props.poNumber : "",
      // searchValue: '',
      suggestions: [],
      searchValue: [],
      isPoDetailsEdit: window.location.pathname == "/PoDetailsEdit" ? true : false,

    };

  }
  componentDidMount() {
  }


  handleDrawerClose = () => {
    this.setState({
      isClosing: true,
      mobileOpen: false
    });
  };

  handleDrawerTransitionEnd = () => {
    this.setState({
      isClosing: false
    });
  };

  handleDrawerToggle = () => {
    const { isClosing, mobileOpen } = this.state;

    if (!isClosing) {
      this.setState(prevState => ({
        mobileOpen: !prevState.mobileOpen
      }));
    }
  };

  handleDrawerToggleTouch = () => {
    const { isClosing, mobileOpen } = this.state;

    if (!isClosing) {
      this.setState(prevState => ({
        mobileOpen: !prevState.mobileOpen
      }));
    }
  };
  handleLogout = async () => {
    ;
    try {
      const token = localStorage.getItem('token');

      const confirmed = await Swal.fire({
        title: 'Are you sure you want to log out?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor:'#055032',
        // cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        confirmButtonText: 'Yes',

      });

      if (confirmed.isConfirmed) {
        const response = await fetch(API_URL + '/api/logout/', {
          method: 'POST',
          headers: {
            'Authorization': `Token ${token}`, // Include Authorization header with token
          },
        });

        if (response.ok) {
          console.log('Logout successful');
          localStorage.removeItem('token');
          window.location.href = '/'; // Redirect to homepage
        } else {
          console.error('Logout failed:', response.statusText);
          // Handle logout failure
        }
      }
    } catch (error) {
      console.error('Error during logout:', error);
      // Handle logout error
    }
  };




  handleChange = (selectedOption) => {
    

    this.setState({ selectedOption: selectedOption })
    this.props.onSelectChange(selectedOption ? selectedOption.value : selectedOption);

  };
  handleChange1 = (selectedOption) => {
    

    axios.get(API_URL + `/api/search-pdf/?query=${selectedOption}`).then((res) => {
      if (res && res.data && res.data) {
        let filteredOptions = []
        if (selectedOption != "") {
          let filteredOptions1 = []

          filteredOptions1 = res.data.filter(option =>
            option.order_name.toLowerCase().includes(selectedOption.toLowerCase())
          );
          filteredOptions = filteredOptions1.map(order => ({
            value: order.order_name,
            label: order.order_name
          }));
        }


        this.setState({
          searchValue: filteredOptions,
        });
      } else {
        this.setState({ searchValue: [] });
      }
    })

  };

  render() {
    // this.state.selectedOpti  on=this.props.poNumber ? this.props.poNumber  :"";

    const { window } = this.props;
    const { searchValue, suggestions } = this.state;

    const drawer = (
      <div>
        <div className="d-flex align-items-center">
          <img src={LogoCM} width="220" height="50" className="d-inline-block align-top" alt="" style={{ marginLeft: "20px", marginTop: "15px" }} />
        </div>
        <Toolbar />

        {/* <Divider /> */}
        <List>
          {/* <ListItem disablePadding component={Link} to="/Overview" selected={this.state.activeLink === '/Overview'} onClick={() => this.setState({ activeLink: '/Overview' })}>
            <ListItemButton>
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Overview" />
            </ListItemButton>
          </ListItem> */}
          <ListItem disablePadding component={Link} to="/PoDetails" selected={this.state.activeLink === '/PoDetails'} onClick={() => this.setState({ activeLink: '/PoDetails' })}>
            <ListItemButton>
              <ListItemIcon>
                <DescriptionIcon />
              </ListItemIcon>
              <ListItemText primary="PO Details" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding onClick={this.handleLogout}>
            <ListItemButton>
              <ListItemIcon>
                <LogoutOutlined />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItemButton>
          </ListItem>
        </List>


      </div>
    );

    // Remove this const when copying and pasting into your project.
    const container = window !== undefined ? () => window().document.body : undefined;

    return (
      <>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar
            position="fixed"
            sx={{
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              ml: { sm: `${drawerWidth}px` },
            }}
          >
            <Toolbar style={{ backgroundColor: "white" }}>
              <IconButton
                // color="red"
                className='MenuIcon'
                aria-label="open drawer"
                edge="start"
                onClick={this.handleDrawerToggle}
                onTouchStart={this.handleDrawerToggleTouch}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div" style={{ color: "black", flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                <span className='NavBar'>PO Details</span>

                {!this.state.isPoDetailsEdit && (
                  <span className='SelectDrop'>
                    <Select
                      value={this.state.selectedOption}
                      onChange={this.handleChange}
                      onInputChange={this.handleChange1}
                      isClearable
                      options={this.state.searchValue}
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          color: 'black' // Change the text color to black
                        }),
                        placeholder: (provided, state) => ({
                          ...provided,
                          fontSize: '16px' // Change the font size of the placeholder
                        })
                      }}
                      menuPortalTarget={document.body}
                      menuPosition={'fixed'}
                      placeholder="Search Po Number...."
                      noOptionsMessage={() => "Search for result"}
                    />
                  </span>
                )}

              </Typography>
            </Toolbar>
          </AppBar>

          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Drawer
              container={container}
              variant="temporary"
              open={this.state.mobileOpen}
              onTransitionEnd={this.handleDrawerTransitionEnd}
              onClose={this.handleDrawerClose}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: 'block', sm: 'none' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
            >
              {drawer}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: 'none', sm: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
          {searchValue && (
            <div className='suggestion-container'>
              {suggestions.map((suggestion, index) => (
                <div key={index} className='suggestion-item'>
                  {suggestion[0]}
                </div>
              ))}
            </div>
          )}
          <Box
            component="main"
            sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
          >
            <Toolbar />
            {/* <Typography paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus non
          enim praesent elementum facilisis leo vel. Risus at ultrices mi tempus
          imperdiet. Semper risus in hendrerit gravida rutrum quisque non tellus.
          Convallis convallis tellus id interdum velit laoreet id donec ultrices.
          Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit
          adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra
          nibh cras. Metus vulputate eu scelerisque felis imperdiet proin fermentum
          leo. Mauris commodo quis imperdiet massa tincidunt. Cras tincidunt lobortis
          feugiat vivamus at augue. At augue eget arcu dictum varius duis at
          consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa
          sapien faucibus et molestie ac.
        </Typography> */}
            <Dialog
              open={this.state.logoutModalOpen}
              onClose={this.handleLogoutCancelled}
              aria-labelledby="logout-confirmation-modal-title"
              aria-describedby="logout-confirmation-modal-description"
            >
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 4,
              }}>
                <h4 id="logout-confirmation-modal-title">Are you sure you want to logout?</h4>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                  <Button onClick={this.handleLogoutConfirmed} variant="contained">Yes</Button>
                  <Button onClick={this.handleLogoutCancelled} sx={{ marginLeft: 1 }} variant="contained">No</Button>
                </Box>
              </Box>
            </Dialog>

          </Box>

        </Box>
        {/* <div className='container'> */}

        {/* </div> */}
      </>
    );
  }
}

SideBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window: PropTypes.func,
};

export default SideBar;
